import { render, staticRenderFns } from "./BaseButtonVue.vue?vue&type=template&id=4c2db2e4&scoped=true&"
import script from "./BaseButtonVue.vue?vue&type=script&lang=ts&"
export * from "./BaseButtonVue.vue?vue&type=script&lang=ts&"
import style0 from "./BaseButtonVue.vue?vue&type=style&index=0&id=4c2db2e4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2db2e4",
  null
  
)

export default component.exports